import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
   const [token, setToken] = useState(
      localStorage.getItem("token") || null
   );

   // const login = (token) => {
   //    localStorage.setItem("token", token);
   //    setToken(token);
   // };

   const login = (data) => {

      localStorage.setItem(
         "token",
         data.token
      );

      localStorage.setItem(
         "user",
         JSON.stringify(data)
      );

      setToken(data.token);
   };

   const logout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("tenantId");
      setToken(null);
   };

   return (
      <AuthContext.Provider value={{ token, login, logout }}>
         {children}
      </AuthContext.Provider>
   );
};

export const useAuth = () => useContext(AuthContext);